
import { createAction, props } from '@ngrx/store';
import { Plan } from '../../models/plan.model';

export const addToCarPlan = createAction('[Adding plan To Car] Add',
  props<{ plan: Plan }>()
);

export const modifyTokenPlan = createAction('[Modify TokenPlan] Modify',
  props<{ id: number, token: string }>()
);

export const removePlanFromCar = createAction('[Removing Plan from Car] Decrement',
props<{ id: number }>()
);
